import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { Widget } from '@pages/IntroducingBroker/Dashboard/CJM/Widget'
// import { DateFilter } from '@pages/IntroducingBroker/Dashboard/QuickPerformance/DateFilter'
import { SectionHeader } from '@pages/IntroducingBroker/Dashboard/components/SectionHeader/SectionHeader'

import { Grid } from '@ui/Layouts/Grid/Grid'
import { Body1 } from '@ui/Typography'
import { TableNoResults } from '@ui/v2/Table/Table'

import { useGAEvents } from '@utils/callGAEvents'

import {
  IntroducingBrokerCJMDetailsDto,
  IntroducingBrokerCJMDto,
} from '@model/IntroducingBrokerCJMDto'

import { Loading } from '@shared/components/Loading/Loading'

import styles from './CJM.module.scss'

interface CJMProps {
  isLoading: boolean
  className?: string
  ibCJMData: IntroducingBrokerCJMDto | undefined
  dateRange: [Date, Date]
  setDateRange: (dateRange: [Date, Date]) => void
}

// DateFilter attributes missing by BE as for now and should be added later
export const CJM = ({ isLoading, className, ibCJMData }: CJMProps) => {
  const { t } = useTranslation()
  const { callGAEvents } = useGAEvents()

  const cjmEntries = ibCJMData ? Object.entries(ibCJMData) : []
  const hasData = cjmEntries.some(([, { value }]) => !!value)

  return (
    <div className={classNames(styles.cjm, className)}>
      <SectionHeader
        title={t('IB.Dashboard.CJM.Clients activation tracking')}
        seeMoreLinkProps={{
          onClick: () => callGAEvents().IBDashboard.CJM.seeMore(),
          to: '/dashboard/introducing-broker/reports/cjm',
        }}
        iconMobileOnly
        tooltipContent={{
          text: t(
            'IB.Dashboard.CJM.Conversion is shown for the clients that have clicked your referral link.'
          ),
        }}
      />
      {/*<div className={styles.filters}>*/}
      {/*  <DateFilter dateRange={dateRange} onDateRangeSelect={setDateRange} />*/}
      {/*</div>*/}
      <Loading isLoading={isLoading} showLoadingIcon>
        {hasData ? (
          <Grid maxCardWidth={165} fixedHeight>
            {cjmEntries.map(([key, value]) => {
              if (key === 'linkClicked') {
                return (
                  <Widget
                    key={key}
                    title={t(`IB.Dashboard.CJM.Total link clicks`)}
                    value={value}
                    shouldRenderFooter={false}
                  />
                )
              }

              const details = value as IntroducingBrokerCJMDetailsDto

              return (
                <Widget
                  key={key}
                  title={t(`IB.Dashboard.CJM.${key}`)}
                  value={details.value}
                  conversionRate={
                    details.value && details.conversionRate ? details.conversionRate : undefined
                  }
                />
              )
            })}
          </Grid>
        ) : (
          <TableNoResults
            title={t('IB.RebatesPage.ClientsPage.No clients to display')}
            content={
              <Body1 color='text-med-em'>
                {t('IB.Dashboard.CJM.Start by distributing your partner link')}
              </Body1>
            }
          />
        )}
      </Loading>
    </div>
  )
}
